/**
 * api_key/v1/api_key.proto
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export const V1TokenType = {
  TokenTypeUnspecified: 'TOKEN_TYPE_UNSPECIFIED',
  TokenTypeOnline: 'TOKEN_TYPE_ONLINE',
  TokenTypeOffline: 'TOKEN_TYPE_OFFLINE',
  TokenTypeHybrid: 'TOKEN_TYPE_HYBRID',
} as const;
export type V1TokenType = (typeof V1TokenType)[keyof typeof V1TokenType];
